import reducer from "./index";

const rootReducer = reducer;

export default rootReducer;
